import AdminForm from "../components/AdminForm";
import { InfoBox } from "./InfoBox";
import { Modal } from "app/components";
import SettingsCard from "./components/SettingsCard";
import { apiRequest } from "app/utils/apiRequests";
import { get } from "lodash";
import { rApp } from "app/utils/recoil";
import { successNotification } from "app/utils/Notification";
import { useRecoilState } from "recoil";
import { useState } from "react";

const Authentication = () => {
  const [app, setApp] = useRecoilState(rApp);

  const [changes, setChanges] = useState(false);
  const [editPublicText, setEditPublicText] = useState(null);

  const authentication = get(app, "authentication", {});

  const save = () => {
    successNotification("Saved");
    setChanges(false);
    apiRequest.post("/app_settings/", {
      authentication: get(app, "authentication"),
    });
  };

  let fields = [
    {
      id: "enableSignup",
      label: "Enable Signup",
      hint: "Enable an auto-generated signup page for your app so users can self-onboard",
      componentId: "Switch",
      value: get(authentication, "enableSignup"),
    },
    {
      id: "forgotPasswordEmailContent",
      label: "Forgot Password Email",
      hint: "Customize the content of the forgot password email that comes before the login link.",
      componentId: "RichTextEditor",
      value: get(authentication, "forgotPasswordEmailContent"),
    },
    {
      label: "Public Text",
      hint: "Edit the public-facing text that appears on the login and signup pages",
      componentId: "Button",
      type: "basic",
      text: "Edit Public Text",
      width: "fit-content",
      icon: "FiEdit",
      onClick: () => setEditPublicText(true),
    },
    {
      id: "requireTerms",
      label: "Require Terms & Conditions",
      componentId: "Switch",
      value: get(authentication, "requireTerms"),
    },
    {
      id: "termsText",
      label: "Terms Text",
      componentId: "Input",
      value: get(authentication, "termsText"),
      displayCondition: () => get(authentication, "requireTerms"),
    },
    {
      id: "termsLinkText",
      label: "Terms Link Text",
      componentId: "Input",
      value: get(authentication, "termsLinkText"),
      displayCondition: () => get(authentication, "requireTerms"),
    },
    {
      id: "termsLink",
      label: "Terms Link",
      componentId: "Input",
      value: get(authentication, "termsLink"),
      displayCondition: () => get(authentication, "requireTerms"),
    },
  ].filter(
    (f) => !f.displayCondition || (f.displayCondition && f.displayCondition(f))
  );

  const publicTextFields = [
    {
      id: "loginHeader",
      label: "Login Header",
      hint: "Override the header text on the login form",
      componentId: "Input",
      value: get(authentication, "loginHeader"),
    },
    {
      id: "signupHeader",
      label: "Sign Up Header",
      hint: "Override the header text on the signup form",
      componentId: "Input",
      value: get(authentication, "signupHeader"),
    },
    {
      id: "emailLabel",
      label: "Email Label",
      hint: "Override the Email field label in the login / signup forms",
      componentId: "Input",
      value: get(authentication, "emailLabel"),
    },
    {
      id: "passwordLabel",
      label: "Password Label",
      hint: "Override the Password field label in the login/signup forms",
      componentId: "Input",
      value: get(authentication, "passwordLabel"),
    },
    {
      id: "firstNameLabel",
      label: "First Name Label",
      hint: "Override the First Name field label in the signup form",
      componentId: "Input",
      value: get(authentication, "firstNameLabel"),
    },
    {
      id: "lastNameLabel",
      label: "Last Name Label",
      hint: "Override the Last Name field label in the signup form",
      componentId: "Input",
      value: get(authentication, "lastNameLabel"),
    },
    {
      id: "noAccountLink",
      label: "No Account Link",
      hint: "Override the 'No Account' link text in the login form",
      componentId: "Input",
      value: get(authentication, "noAccountLink"),
    },
    {
      id: "haveAccountLink",
      label: "Have Account Link",
      hint: "Override the 'Have An Account' link text in the signup form",
      componentId: "Input",
      value: get(authentication, "haveAccountLink"),
    },
    {
      id: "forgotPasswordLink",
      label: "Forgot Password Link",
      hint: "Override the 'Forgot Password' link text in the login/signup forms",
      componentId: "Input",
      value: get(authentication, "forgotPasswordLink"),
    },
    {
      id: "enterEmailPasswordReset",
      label: "Forgot Password Text 1",
      hint: "Override the 'Enter your email...' text in the forgot password popup",
      componentId: "Input",
      value: get(authentication, "enterEmailPasswordReset"),
    },
    {
      id: "sendPasswordResetEmail",
      label: "Send Password Reset Button",
      hint: "Override the 'Send Password Reset Email' button text in the forgot password popup",
      componentId: "Input",
      value: get(authentication, "sendPasswordResetEmail"),
    },
    {
      id: "emailSent",
      label: "Email Sent",
      hint: "Override the 'Forgot Password Email Sent' notification text",
      componentId: "Input",
      value: get(authentication, "emailSent"),
    },
  ];

  return (
    <>
      {editPublicText && (
        <Modal
          header={{ title: "Edit Public Text" }}
          hide={() => setEditPublicText(null)}
        >
          <AdminForm
            labelStyle="headingSm"
            sectionPadding="5px"
            fields={publicTextFields}
            submitText={"Save Changes"}
            submit={changes && save}
            gridLayout
            onChange={(k, v) => {
              setChanges(true);
              setApp({
                authentication: {
                  ...authentication,
                  [k]: v,
                },
              });
            }}
          />
        </Modal>
      )}

      <SettingsCard
        label="Other Settings"
        description="Enable/disable signup, require terms, and other settings"
      >
        <AdminForm
          labelStyle="headingSm"
          sectionPadding="5px"
          fields={fields}
          submitText={"Save Changes"}
          submit={changes && save}
          orientation={"horizontal"}
          width="220px"
          onChange={(k, v) => {
            setChanges(true);
            setApp({
              authentication: {
                ...authentication,
                [k]: v,
              },
            });
          }}
        />
        <InfoBox margin="15px 5px 5px 5px">
          Login and signup pages are auto-generated, but you can disable the
          signup page.
        </InfoBox>
      </SettingsCard>
    </>
  );
};

export default Authentication;
